<template>
  <div class="mt-4">
    <h1 class="title text-uppercase font-weight-bold">Produtos para aprovação</h1>

    <hr class="linha-amarela" />

    <div class="mt-4">
      <table class="table table-striped table-bordered">
        <thead class="letter-orange">
            <th>Produto</th>
            <th class="text-center">Cod. barras</th>
            <th class="text-center">Marca</th>
            <th class="text-center">Unidade</th>
            <th class="text-center">Peso (Kg)</th>
            <th class="text-center">Altura (Cm)</th>
            <th class="text-center">Largura (Cm)</th>
            <th class="text-center">Comprimento (Cm)</th>
            <th class="text-center">Lojista ID</th>
            <th class="text-center" style="width: 220px">Ações</th>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data" :key="index">
            <td>{{ item.produto }}</td>
            <td class="text-center">{{ item.codbar }}</td>
            <td class="text-center">{{ item.marca }}</td>
            <td class="text-center">{{ item.unidade }}</td>
            <td class="text-center">{{ item.peso }}</td>
            <td class="text-center">{{ item.altura }}</td>
            <td class="text-center">{{ item.largura }}</td>
            <td class="text-center">{{ item.comprimento }}</td>
            <td class="text-center">
              <span class="cursor-pointer" @click="buscarNomeLojista(item.lojista_id)">
                {{ item.lojista_id }}
              </span>
            </td>
            <td class="text-center">
              <span
                class="btn btn-success mr-2"
                @click="novoStatus(item.id, 2)"
                v-b-tooltip.hover
                :title="'Liberar só para o lojista ' + item.lojista_id"
              >
                <i class="fas fa-check"></i>
              </span>

              <span
                class="btn btn-info mr-2"
                @click="novoStatus(item.id, 4)"
                v-b-tooltip.hover
                title="Liberar para todos os lojistas"
              >
                <i class="fas fa-users"></i>
              </span>

              <span
                class="btn btn-primary mr-2"
                @click="visualizar(item)"
                v-b-tooltip.hover
                title="Ver o produto"
              >
                <i class="fas fa-eye"></i>
              </span>

              <span
                class="btn btn-danger"
                @click="novoStatus(item.id, 3)"
                v-b-tooltip.hover
                title="Reprovar produto"
              >
                <i class="fas fa-times"></i>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <b-modal
      title="Foto do produto"
      size="xl"
      id="modalImagem"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <b-row>
        <b-col cols="12">
          <img :src="urlImagem" style="width: 100%;">
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      title="Detalhes do produto"
      size="xl"
      id="modalProduto"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer>
      <b-row>
        <b-col cols="9" class="mb-2">
          <label>Nome do produto <span class="text-danger d-inline">*</span></label>
          <input type="text" class="form-control" v-model="dataProduct.produto" placeholder="Nome do produto">
          <span class="text-danger d-inline" v-if="error.produto">Informe o nome do produto</span>
        </b-col>

        <b-col cols="3" class="mb-2">
          <label>Código de barra <span class="text-danger d-inline">*</span></label>
          <input type="text" class="form-control" v-model="dataProduct.codbar" @blur="buscarCodBar()" placeholder="Código de barras">
          <span class="text-danger d-inline" v-if="error.codbar">Informe o Cód. barras</span>
        </b-col>

        <b-col cols="2" class="mb-2">
          <label>Marca <span class="text-danger d-inline">*</span></label>
          <input type="text" class="form-control" v-model="dataProduct.marca" placeholder="Marca do produto">
          <span class="text-danger d-inline" v-if="error.marca">Informe a marca</span>
        </b-col>

        <b-col cols="2" class="mb-2">
          <label>Unidade de medida <span class="text-danger d-inline">*</span></label>
          <input type="text" class="form-control" v-model="dataProduct.unidade" placeholder="Un, Kg, Cm...">
          <span class="text-danger d-inline" v-if="error.unidade">Informe a Unidade de medida</span>
        </b-col>

        <b-col cols="2" class="mb-2">
          <label>Peso (Kg)<span class="text-danger d-inline">*</span></label>
          <input type="text" class="form-control" v-model="dataProduct.peso" placeholder="Peso do produto" v-money="formatTipo">
          <span class="text-danger d-inline" v-if="error.peso">Informe o peso do produto</span>
        </b-col>

        <b-col cols="2" class="mb-2">
          <label>Altura (Cm)<span class="text-danger d-inline">*</span></label>
          <input type="text" class="form-control" v-model="dataProduct.altura" placeholder="Altura do produto" v-money="formatTipo">
          <span class="text-danger d-inline" v-if="error.altura">Informe a altura</span>
        </b-col>

        <b-col cols="2" class="mb-2">
          <label>Largura (Cm)<span class="text-danger d-inline">*</span></label>
          <input type="text" class="form-control" v-model="dataProduct.largura" placeholder="Largura do produto" v-money="formatTipo">
          <span class="text-danger d-inline" v-if="error.largura">Informe a largura</span>
        </b-col>

        <b-col cols="2" class="mb-2">
          <label>Comprimento (Cm)<span class="text-danger d-inline">*</span></label>
          <input type="text" class="form-control" v-model="dataProduct.comprimento" placeholder="Comprimento do produto" v-money="formatTipo">
          <span class="text-danger d-inline" v-if="error.comprimento">Informe o comprimento</span>
        </b-col>

        <b-col cols="12" class="mb-2">
          <label>Descrição do produto (Opcional)</label>
          <textarea class="form-control" rows="3" placeholder="Descrição do produto" v-model="dataProduct.descricao"></textarea>
        </b-col>

        <b-col cols="12" class="mb-2 mt-2">
          <label>Categoria: <span class="text-danger d-inline">*</span></label>
          <span class="ml-2"><b>{{categoria}}</b></span>
          <span class="btn btn-primary float-right mb-1" @click="limparCategoria()">Limpar</span>

          <select class="custom-select mb-3" @change="selectId()" v-model="categoriaSelect" v-show="validLink == false">
            <option selected value="">-- Selecione a categoria {{count+1}} --</option>
            <option v-for="(item, i) in categorias" :key="i" :value="item">{{item.nome_departamento}}</option>
          </select>
          <span class="text-danger d-inline" v-if="error.departamento_id">Informe a categoria</span>
        </b-col>

        <b-col cols="6" class="mt-2">
          <label>Ficha(s) tec. (Opcional)</label>
          <span class="btn btn-primary float-right" @click="openModalFicha()">+</span>

          <table class="table table-striped table-bordered mt-2">
            <thead>
              <tr>
                <th scope="col">Tipo</th>
                <th scope="col">Descrição</th>
                <th scope="col" class="text-center">Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in dataProduct.produto_fichas" :key="i" v-show="item.tipo != null">
                <td>{{item.tipo}}</td>
                <td>{{item.descricao}}</td>
                <td class="text-center">
                  <span class="cursor-pointer" style="color:red" @click="removerFicha(i, item)">
                    <i class="fas fa-trash"></i>
                  </span>
                </td>
              </tr>
              <tr v-if="dataProduct.produto_fichas && dataProduct.produto_fichas.length == 0">
                <td colspan="3">
                  <span>Sem ficha tec. cadastrada!</span>
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>

        <b-col cols="6" class="mt-2">
          <label>Imagem do produto:</label>
          <input type="file" id="file" ref="file" accept="image/*" @change="uploadImage()" class="form-control">
          <span class="text-danger d-inline" v-if="error.fotos">Informe a(s) foto(s)</span>

          <b-row>
            <b-col cols="2" class="mt-2 mr-2 text-center" v-for="(item, i) in dataProduct.produto_fotos" :key="i">
              <span class="cursor-pointer" style="color:red" @click="removerFoto(i, item)">
                <i class="fas fa-times-circle"></i>
              </span>
              <img 
                :src="formatUrl(item.foto_png ? item.foto_png : item)"
                :alt="dataProduct.produto+' - '+i"
                @click="openImg(formatUrl(item.foto_png ? item.foto_png : item))"
                width="70" 
                class="cursor-pointer"
              >
            </b-col>
          </b-row>
        </b-col>

        <b-modal
          title="Nova ficha tec."
          size="md"
          id="modalFicha"
          header-bg-variant="orange"
          header-text-variant="light"
          centered
          hide-footer>
          <b-row>
            <b-col cols="6" class="mb-2">
              <label>Tipo:</label>
              <input type="text" class="form-control" v-model="tipo" placeholder="Ex: Cor:">
            </b-col>

            <b-col cols="6" class="mb-2">
              <label>Descrição:</label>
              <input type="text" class="form-control" v-model="descricao" placeholder="Ex: Azul">
            </b-col>

            <b-col cols="12" class="mt-2 text-center">
              <button class="btn btn-success" @click="addFicha()">Salvar ficha tec.</button>
            </b-col>
          </b-row>
        </b-modal>

        <b-col cols="12" class="text-center mt-4 mb-2">
          <button class="btn btn-primary mr-2" @click="atualizarStatus(true)">Alterar e aprovar</button>
          <button class="btn btn-success mr-2" @click="atualizarStatus(false)">Só alterar</button>
          <button class="btn btn-danger" @click="novoStatus(item.id, 3)">Excluir produto</button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import makeToast from 'Mixins/makeToast';
export default {
  mixins: [makeToast],
  
  name: 'ProdutosAprovacao',
  data() {
    return {
      data: [],
      urlImagem: '',
      categoriaSelect: '',
      categoria: '',
      categorias: [],
      count: 0,
      tipo: null,
      corbar: null,
      validLink: true,
      descricao: null,
      valid: false,
      dataProduct: {
        produto: null,
        codbar: null,
        marca: null,
        uni_med: null,
        peso: null,
        altura: null,
        largura: null,
        comprimento: null,
        departamento_id: null,
        lojista_id: null,
        aprovar: false,
        produto_fichas: [],
        produto_fichas_remover: [],
        produto_fotos: [],
        produto_fotos_remover: []
      },
      error: {
        produto: false,
        codbar: false,
        marca: false,
        uni_med: false,
        peso: false,
        altura: false,
        largura: false,
        comprimento: false,
        departamento_id: false,
        fichas: false,
        fotos: false
      },
      formatTipo: {
        decimal: '.',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true
      },
    };
  },


  computed: {
    ...mapState(['token', 'dadosUsuario']),
  },

  created() {
    this.buscarProdutos();
  },

  methods: {
    openImg(url) {
      this.urlImagem = url;
      this.$bvModal.show('modalImagem');
    },
    visualizar(item) {
      this.limpaErro();

      this.dataProduct = item;
      this.corbar = item.codbar;
      this.categoria = item.departamento;
      this.validLink = true;

      this.$bvModal.show('modalProduto');
    },
    atualizar(aprovar) {
      const valid = this.validarForm();
      if(valid == true) {
        this.makeToast('Oops!', 'Corrija os erros acima para cadastrar o produto!', 'danger');
        return;
      }

      this.dataProduct.aprovar = aprovar;
    },
    buscarProdutos() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/bucarNovoProduto')
        .then((response) => {
          this.data = response.data;
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    novoStatus(id, status) {

      var params = {
        id: id,
        status: status
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/bucarNovoUpStatus', params)
        .then(() => {
          this.buscarProdutos();

          this.makeToast('Sucesso!', 'Status atualizado!', 'success');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    atualizarStatus(aprovar) {

      if(aprovar == true) {
        this.dataProduct.cad_status = 2;
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/bucarNovoUpStatusRequest', this.dataProduct)
        .then((response) => {
          if(response.data.error == false) {
            this.limpaProduto();
            this.buscarProdutos();

            this.makeToast('Sucesso!', 'Produto atualizado!', 'success');

            this.$bvModal.hide('modalProduto');
          } else {
            this.makeToast('Opss!', 'Não foi possíve alterar o status!', 'danger');
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    removerFicha(i, item) {
      if(!this.dataProduct.produto_fichas_remover) {
        this.dataProduct.produto_fichas_remover = [];
      }
      
      this.dataProduct.produto_fichas_remover.push(item);
      this.dataProduct.produto_fichas = this.dataProduct.produto_fichas.filter((elemento, index) => index !== i);
    },
    removerFoto(i, item) {
      if(!this.dataProduct.produto_fotos_remover) {
        this.dataProduct.produto_fotos_remover = [];
      }

      this.dataProduct.produto_fotos_remover.push(item);
      this.dataProduct.produto_fotos = this.dataProduct.produto_fotos.filter((elemento, index) => index !== i);
    },
    selectId() {
      const item = this.categoriaSelect;

      const seta = this.count == 0 ? '' : ' -> ';
      
      this.categoria = this.categoria+seta+item.nome_departamento;

      if(item.link == true) {
        this.validLink = true;
        this.dataProduct.departamento_id = item.id;
        this.error.departamento_id = false;
      } else {
        this.count = this.count +1;
        this.categoriaSelect = '';

        this.buscarCategoria(item.id);
      }
    },
    limparCategoria() {
      this.validLink = false;
      this.count = 0;
      this.categoriaSelect = '';
      this.categoria = '';
      this.dataProduct.departamento_id = null;

      this.buscarCategoria(0);
    },
     buscarCategoria(id) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/buscarCategorias', id)
        .then((response) => {
          this.categorias = response.data;
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    buscarCodBar() {
      if(this.corbar == this.dataProduct.codbar) {return}
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/buscarCodBar', this.dataProduct.codbar)
        .then((response) => {
          if(response.data.id) {
            this.dataProduct.codbar = this.corbar;
            this.makeToast('Oops!', 'Esse código de barras já existe, informe outro!', 'danger');
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    uploadImage() {
      const formData = new FormData();
      this.imageSelected = this.$refs.file.files[0];
      formData.append('file', this.imageSelected);

      this.$store.dispatch('startLoader');
      this.$store.dispatch('files/uploadFileNewProduct', formData)
      .then((response) => {
        const file = response.data.data;
        this.dataProduct.produto_fotos.push(file)
      })
      .catch(() => {
        this.makeToast('Oops!', 'Não foi possível inserir a imagem, tente novamente!', 'danger');
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
    },
    openModalFicha() {
      this.tipo = null;
      this.descricao = null;
      this.$bvModal.show('modalFicha');
    },
    formatUrl(foto) {
      return process.env.VUE_APP_FOTOS_URL+foto;
    },
    addFicha() {
      this.dataProduct.produto_fichas.push({tipo: this.tipo, descricao: this.descricao});
      this.$bvModal.hide('modalFicha');
    },
    buscarNomeLojista(id) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/nomeLojista', id)
        .then((response) => {
          if(response.data.nome_fantasia) {
            this.makeToast(
              response.data.nome_fantasia+ ' - CNPJ:'+response.data.cnpj, 
              'Endereço:'+response.data.endereco+', '+response.data.nome+'-'+response.data.uf, 
              'success',
              'b-toaster-top-right',
              10000
            );
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    validarForm() {
      this.limpaErro();
      var valid = false;

      if(this.dataProduct.produto == null || this.dataProduct.produto == '') {
        this.error.produto = true;
        valid = true;
      }
      if(this.dataProduct.codbar == null || this.dataProduct.codbar == '') {
        this.error.codbar = true;
        valid = true;
      }
      if(this.dataProduct.marca == null || this.dataProduct.marca == '') {
        this.error.marca = true;
        valid = true;
      }
      if(this.dataProduct.unidade == null || this.dataProduct.unidade == '') {
        this.error.unidade = true;
        valid = true;
      }
      if(this.dataProduct.peso == null || this.dataProduct.peso == '0.00') {
        this.error.peso = true;
        valid = true;
      }
      if(this.dataProduct.altura == null || this.dataProduct.altura == '0.00') {
        this.error.altura = true;
        valid = true;
      }
      if(this.dataProduct.largura == null || this.dataProduct.largura == '0.00') {
        this.error.largura = true;
        valid = true;
      }
      if(this.dataProduct.comprimento == null || this.dataProduct.comprimento == '0.00') {
        this.error.comprimento = true;
        valid = true;
      }
      if(this.validLink == false) {
        this.error.departamento_id = true;
        valid = true;
      }
      if(this.dataProduct.produto_fotos.length == 0) {
        this.error.fotos = true;
        valid = true;
      }

      return valid;
    },
  limpaProduto(){
    this.dataProduct.produto = null;
    this.dataProduct.codbar = null;
    this.dataProduct.marca = null;
    this.dataProduct.unidade = null;
    this.dataProduct.peso = null;
    this.dataProduct.altura = null;
    this.dataProduct.largura = null;
    this.dataProduct.comprimento = null;
    this.dataProduct.descricao = null;
    this.dataProduct.departamento_id = null;
    this.dataProduct.lojista_id = null;
    this.dataProduct.produto_fichas = [];
    this.dataProduct.produto_fotos = [];
    this.produto_fotos_remover = [];   
  },
  limpaErro(){
      this.error.produto = false;
      this.error.codbar = false;
      this.error.marca = false;
      this.error.unidade = false;
      this.error.peso = false;
      this.error.altura = false;
      this.error.largura = false;
      this.error.comprimento = false;
      this.error.departamento_id = false;
      this.error.produto_fichas = false;
      this.error.produto_fotos = false;        
  }
  },
}
</script>
